<template>
<div class="chapter">
<div class="inner_page">
<div class="TitlePage">
<h1>Excellence in Preaching</h1>
<div>
<p class="Author sgc-1">Studying the Craft of Leading Preachers</p>
<p class="Author sgc-1">Simon Vibert</p>
</div>
<p class="IVPcenter"><img alt="IVP Books Imprint" src="Images/IVP_Books_Quarter.jpg"/></p>
<p class="IVPcenter"><a href="http://www.IVPress.com/books/" target="_blank">www.IVPress.com/books</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?69c6dfac